// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"160":"bf0086df3550fbe6","325":"39c7419ae8aaa049","374":"1a95d84021f6cdc3","444":"3924b92dec7579c6"}[chunkId] + ".js";
};